import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { closeErrorModal } from '../../../../actions/error-modal.action';
import { AppModalConstant } from '../../../../constants/app-modal.constant';


export class ErrorModal extends Component {

    closeErrorModal = () => {
        const { closeErrorModal } = this.props;
        closeErrorModal();
    }

    render() {
        const { modalTitle, errorMessage } = this.props;
        return (
            <Fragment>
                <div className="modal-header">
                    <h3 className="margin-top-0 ng-isolate-scope">{modalTitle}</h3>
                </div>
                <div className="modal-body">
                    {errorMessage ? errorMessage : AppModalConstant.GENERIC_ERROR_MESSAGE}
                </div>
                <div className="modal-footer">
                    <div className="action margin-top-20">
                        <button type="button" className="btn ng-isolate-scope" onClick={() => this.closeErrorModal()} autoFocus=""> {AppModalConstant.ERROR}
                        </button>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    closeErrorModal: () => dispatch(closeErrorModal())
})

const mapStateToProps = state => {
    return {
        modalTitle: state.modalInfo.activeModal.modalTitle,
        errorMessage: state.modalInfo.errorMsg
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);